import { render, staticRenderFns } from "./MemberBreakConfiguration.vue?vue&type=template&id=59504a63&scoped=true&"
import script from "./MemberBreakConfiguration.vue?vue&type=script&lang=js&"
export * from "./MemberBreakConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./MemberBreakConfiguration.vue?vue&type=style&index=0&id=59504a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59504a63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59504a63')) {
      api.createRecord('59504a63', component.options)
    } else {
      api.reload('59504a63', component.options)
    }
    module.hot.accept("./MemberBreakConfiguration.vue?vue&type=template&id=59504a63&scoped=true&", function () {
      api.rerender('59504a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/MemberBreakConfiguration.vue"
export default component.exports